<template>
    <div>
        <div class="title">
            <Breadcrumb>
                <BreadcrumbItem :to='{ path: "/ebilling/costAllocation",query: { pageNum: this.$route.query.pageNum,pageSize: this.$route.query.pageSize}}'>{{$t('Bill.CostAllocation.title')}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.id ? this.$t('alarms.common.edit') : this.$t('alarms.common.add') }}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <Form ref="costAllocationForm" :model="costAllocationForm" :rules="ruleValidate">
            <!-- 基本信息 -->
            <Row :gutter="10" style="margin-bottom: 20px;">
                <Col span="24">
                    <Card>
                        <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{ $t("resourceLifecycle.basicInformation") }}</p>
                        <Row :gutter="4">
                            <FormItem label="" :label-width="100">
                                <Col span="10">
                                    <!-- 表名 -->
                                    <FormItem :label="$t('Bill.CostAllocation.tableName')" prop="tableName">
                                        <Input type="text" v-model="costAllocationForm.tableName"></Input>
                                    </FormItem>
                                </Col>
                                <Col span="10">
                                    <!-- 应用名 -->
                                    <FormItem :label="$t('Bill.CostAllocation.applicationName')" prop="apportionApplicationName">
                                        <Select v-model="costAllocationForm.apportionApplicationName" filterable :transfer="true" placeholder="" allow-create @on-create="handleApplicationNameCreate($event)">
                                            <Option :value="item.name" v-for="(item,index) in applicationNameList" :key="index">{{item.name}}</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                            </FormItem>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <!-- 成本中心 -->
            <Row :gutter="10" style="margin-bottom: 10px;">
                <Col span="24">
                    <Card>
                        <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{ $t("Bill.CostAllocation.costCenter") }}</p>
                        <Row :gutter="16">
                            <Col span="24">
                                <FormItem label="" :label-width="100">
                                    <!-- 成本中心 -->
                                    <div v-for="(item,index) in costAllocationForm.apportionCostCenterRelationshipDTOList" :key="index">
                                        <Row :gutter="4" style="margin-bottom:20px;">
                                            <Col span="10">
                                                <!-- 名称 -->
                                                <FormItem :label="$t('Bill.CostAllocation.name')" :prop="'apportionCostCenterRelationshipDTOList.'+index+'.costCenterName'" :rules="[{required:true, message: '名称不能为空', trigger: 'change',type: 'string'}]">
                                                    <Select v-model="item.costCenterName" filterable :transfer="true" placeholder="" allow-create @on-create="handleNameCreate($event)">
                                                        <Option :value="item.costCenterName" v-for="(item,index) in showCostCenterNameList(item.costCenterName)" :key="index">{{item.costCenterName}}</Option>
                                                    </Select>
                                                </FormItem>
                                            </Col>
                                            <Col span="10">
                                                <!-- 分摊比例 -->
                                                <FormItem :label="$t('Bill.CostAllocation.proportionOfContribution')" :prop="'apportionCostCenterRelationshipDTOList.'+index+'.costCenterPercentageValue'" :rules="[{required:true, message: '请输入分摊比例(%)', trigger: 'blur',type: 'number'},{validator(rule, value, callback){
                                                    var errors = [];
                                                    let sum = 0;
                                                    for (var x=0;x< costAllocationForm.apportionCostCenterRelationshipDTOList.length;x++){
                                                        sum += Number(costAllocationForm.apportionCostCenterRelationshipDTOList[x].costCenterPercentageValue);
                                                    }
                                                    if (sum!=100) {
                                                        callback('分摊比例相加之和需为100%');
                                                    }
                                                    callback(errors);
                                                }}]">
                                                    <InputNumber :min="0" v-model="item.costCenterPercentageValue" style="width:100%;"></InputNumber>
                                                </FormItem>
                                            </Col>
                                            <Col span="4" class="action">
                                                <FormItem :label="$t('BillingServices.oper')">
                                                    <Button @click="handleRemoveCostCenter(index)">{{ $t('BillingServices.del') }}</Button>
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Row>
                                        <Col span="20">
                                            <Button type="dashed" long @click="handleAddCostCenter" icon="md-add" style="width:100%;">{{ $t("BillingServices.add") }}</Button>
                                        </Col>
                                    </Row>
                                </FormItem>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Form>
        <div slot="footer" style="float: right;">
            <Button @click="backtrack">{{ $t("alarms.common.back") }}</Button>
            <Button type="primary" @click="submit('costAllocationForm')" :loading="loading">{{ $t("resourceLifecycle.submit") }}</Button>
        </div>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    var costAllocationVue = {}
    export default {
        data () {
            var validateTableName = (rule, value, callback) => {
                if(this.costAllocationForm.apportionApplicationName){
                    this.$refs.costAllocationForm.validateField('apportionApplicationName');
                }
                callback();
            };
            var validateApportionApplicationName = (rule, value, callback) => {
                if(this.costAllocationForm.tableName){
                    var self = this;
                    self.$api.apportion.checkApportionIsExist({
                        "id": parseInt(this.$route.query.id),
                        "tableName": this.costAllocationForm.tableName,
                        "apportionApplicationName": this.costAllocationForm.apportionApplicationName
                    })
                    .then(res => {
                        if (res.status == 200) {
                            callback();
                        }
                    })
                    .catch(err => {
                        if (err.status == 400) {
                            callback(new Error('表名+应用名不能重复!'));
                        }
                    })
                }else{
                    callback();
                }
            };
            return {
                loading: false,
                costCenterList:[],
                applicationNameList:[],
                costAllocationForm: {
                    tableName:'',
                    apportionApplicationName:'',
                    apportionCostCenterRelationshipDTOList:[{
                        costCenterName:'',
                        costCenterPercentageValue:null
                    }]
                },
                ruleValidate: {
                    tableName: [
                        {required: true, message: '请输入表名', trigger: 'blur'},
                        {validator: validateTableName, trigger: 'blur'}
                    ],
                    apportionApplicationName: [
                        {required: true, message: '请输入应用名', trigger: 'change',type: 'string'},
                        {validator: validateApportionApplicationName, trigger: 'change',type: 'string'}
                    ]
                }
            }
        },
        beforeCreate: function () {
            costAllocationVue = this
        },
        mounted:function(){
            // 查询列表
            costAllocationVue.searchAll();
            // 编辑
            if(this.$route.query.id){
                this.select();
            }
        },
        computed: {
            // 成本中心名称不能重复选择
            showCostCenterNameList() {
                return (val) => {
                    let newList = JSON.parse(JSON.stringify(this.costCenterList));
                    const arr = this.costAllocationForm.apportionCostCenterRelationshipDTOList.map(item => {
                        return (item = item.costCenterName);
                    });
                    newList = newList.filter(item => {
                        if (val == item.costCenterName) {
                            return item;
                        } else {
                            if (arr.indexOf(item.costCenterName) == -1) {
                                return item;
                            }
                        }
                    });
                    return newList;
                };
            }
        },
        methods:{
            /**********************多个成本中心************************************/
            // 添加成本中心
            handleAddCostCenter () {
                this.costAllocationForm.apportionCostCenterRelationshipDTOList.push({
                    costCenterName:'',
                    costCenterPercentageValue:null
                })
            },
            // 删除成本中心
            handleRemoveCostCenter (index) {
                if (this.costAllocationForm.apportionCostCenterRelationshipDTOList.length === 1) {
                    this.$Message.warning('至少需要一个子维度')
                    return
                }
                this.costAllocationForm.apportionCostCenterRelationshipDTOList.splice(index, 1)
            },
            /*********************************  编辑  ************************************/
            select:function(){
                this.$api.apportion.select("id",this.$route.query.id)
                .then(res => {
                    // 表名
                    this.costAllocationForm.tableName=res.data.tableName;
                    // 应用名
                    this.costAllocationForm.apportionApplicationName=res.data.apportionApplicationName;
                    // 成本中心
                    this.costAllocationForm.apportionCostCenterRelationshipDTOList=res.data.apportionCostCenterRelationshipDTOList;
                })
            },
            /**************************************  查询  **************************************/
            // 查询所有
            searchAll: function(){
                // 成本中心
                costAllocationVue.apportionCostCenterSelect();
                // 应用名
                costAllocationVue.selectApportionApplication();
            },
            /*******************名称****************/
            // 成本中心
            apportionCostCenterSelect:function(){
                this.$api.apportionCostCenter.apportionCostCenterSelect({})
                .then(res => {
                    this.costCenterList=res.data;
                })
            },
            // 创建新的名称
            handleNameCreate (val) {
                const name = this.costCenterList.find(x => x.costCenterName === val)
                if(name==undefined){
                    this.costCenterList.push({
                        costCenterName: val
                    });
                }
            },
            /*******************应用名****************/
            // 应用名
            selectApportionApplication:function(){
                this.$api.apportionApplication.selectApportionApplication({})
                .then(res => {
                    this.applicationNameList=res.data;
                })
            },
            // 创建新应用名
            handleApplicationNameCreate (val) {
                const tmp = this.applicationNameList.find(x => x.name === val)
                if(tmp==undefined){
                    this.applicationNameList.push({
                        name: val
                    });
                }
            },
            // 创建
            /**********************************************************************************/
            submit: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        var costAllocationDate={
                            "tableName": this.costAllocationForm.tableName,
                            "apportionApplicationName": this.costAllocationForm.apportionApplicationName,
                            "apportionCostCenterRelationshipDTOList": this.costAllocationForm.apportionCostCenterRelationshipDTOList
                        };
                        if(this.$route.query.id){
                            costAllocationDate.id=this.$route.query.id;
                            // 编辑
                            costAllocationVue.$api.apportion.update(costAllocationDate)
                            .then(res => {
                                setTimeout(() => {
                                    this.loading = false;
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success('编辑成功');
                                    this.$router.push({path: '/ebilling/costAllocation',query: { pageNum: this.$route.query.pageNum,pageSize: this.$route.query.pageSize}});

                                },1000);
                            })
                        }else{
                            // 添加
                            costAllocationVue.$api.apportion.add(costAllocationDate)
                            .then(res => {
                                setTimeout(() => {
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success('添加成功');
                                    this.$router.push({path:'/ebilling/costAllocation'});
                                    this.$router.push({query: {}});

                                },1000);
                            })
                        }
                    }else{
                        this.loading = false;
                        if(this.$route.query.id>0){
                            this.$Message.error('编辑失败');
                        }else{
                            this.$Message.error('添加失败');
                        }
                    }
                });
            },
            // 返回
            backtrack: function(){
                this.$router.push({path: '/ebilling/costAllocation',query: { pageNum: this.$route.query.pageNum,pageSize: this.$route.query.pageSize}});
            }
        }
    }
</script>
<style scoped>
    .title
    {
        width: 100%;
        height: 48px;
        background-color: #fff;
        border-bottom: 2px solid #eaeceb;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 14px;
        margin-bottom: 20px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .action>>>.ivu-form-item-label
    {
        width:100%;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/ebilling/cost_allocation/AddOrUpdateCostAllocation.vue